module.exports = __webpack_public_path__ + "media/images/icons/facebook_black-2dc5223f2774ae40e35f361e7869fab9.svg";